import React from "react";

import B64 from "base-64";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { AiTwotoneEye, AiTwotoneEyeInvisible } from "react-icons/ai";

import { ICadastro } from "../../../models";
import { CriarUsuario } from "../../../servicos";
import { Wrapper, Erro } from "./styles";
import { Mensagem } from "../../../componentes";

export default function Cadastro() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [mensagem, setMensagem] = React.useState("");
  const [tipo, setTipo] = React.useState("");
  const [type, setType] = React.useState("password");

  const onSubmit = (data: ICadastro) => {
    let validaEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (!validaEmail.test(data.email)) {
      setMensagem("Email inválido!");
      setTipo("erro");
      setTimeout(() => {
        setMensagem("");
      }, 5000);
      return;
    }
    if (data.senha.length < 6) {
      setMensagem("Senha deve ter no mínimo 6 dígitos!");
      setTipo("erro");
      setTimeout(() => {
        setMensagem("");
      }, 5000);
      return;
    }
    criarUsuario(data.nome, data.email, data.senha);
  };

  const criarUsuario = async (nome: string, email: string, senha: string) => {
    if (navigator.onLine) {
      try {
        const senhaB64 = B64.encode(senha);
        const dadosUpdate = {
          nome: nome,
          email: email,
          senha: senhaB64,
        };
        const resultado = await CriarUsuario(dadosUpdate);
        if (resultado.data.success) {
          setMensagem("Conta criada com sucesso!");
          setTipo("sucesso");
          setValue("nome", "");
          setValue("email", "");
          setValue("senha", "");
          setValue("checkbox", "");
        }
      } catch (err) {
        setMensagem("Lamento, falha na comnunicação com o servidor!");
        setTipo("erro");
      } finally {
        setTimeout(() => {
          setMensagem("");
        }, 5000);
      }
    } else {
      setMensagem("É necessário conexão com a internet!");
      setTipo("erro");
    }
  };

  const visualizarSenha = () => {
    if (type === "password") {
      setType("text");
    } else {
      setType("password");
    }
  };

  return (
    <Wrapper>
      <svg className="pentagono" viewBox="0 0 250 236">
        <polygon
          fill="#fff"
          points="124 1 247.64 90.83 200.41 236.17 48.41 236.17 0.36 90.83"
        ></polygon>
      </svg>
      <h2>CADASTRO</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input {...register("nome", { required: true })} placeholder="Nome" />
        {errors.nome && (
          <Erro>
            <span>O campo nome é obrigatório!</span>
          </Erro>
        )}
        <input
          {...register("email", { required: true })}
          placeholder="E-mail"
        />
        {errors.email && (
          <Erro>
            <span>O campo email é obrigatório!</span>
          </Erro>
        )}
        <div className="container-password">
          <input
            {...register("senha", { required: true })}
            placeholder="Senha"
            type={type}
          />
          <button type="button" onClick={visualizarSenha}>
            {type === "password" ? <AiTwotoneEyeInvisible /> : <AiTwotoneEye />}
          </button>
        </div>
        {errors.senha && (
          <Erro>
            <span>O campo senha é obrigatório!</span>
          </Erro>
        )}

        <div className="container-captcha">
          <div>
            <input
              type="checkbox"
              id="valido"
              {...register("checkbox", { required: true })}
            />
            <label htmlFor="valido">
              <span></span>
              Não sou um robô
            </label>
          </div>
        </div>
        <div className="container-captcha">
          {errors.checkbox && (
            <Erro>
              <span>Mostre-nos que você não é um robô!</span>
            </Erro>
          )}
        </div>

        <input className="input-submit" type="submit" value="CADASTRAR" />
      </form>
      <Link to="/login">Voltar</Link>
      {mensagem ? <Mensagem tipo={tipo} frase={mensagem} /> : null}
    </Wrapper>
  );
}
